module.exports = __webpack_public_path__ + "img/customer-a-044.067bb88e.png";